import { Apollo_gql, GraphPayload, GraphQueryPayload, graphQlTake } from '@camelot/server';

import { paymentLinkProps } from './dto/payment-link';

export function GET_INVOICES(where: string, props: string, take?: number): GraphQueryPayload {
  return {
    query: Apollo_gql`
      query Invoices {
        invoices(${where}, ${graphQlTake(take)}) {
          items {
            ${props}
          }
        }
      }
    `,
    variables: {},
  };
}

export function GET_PAYMENT_LINK(
  id: string,
  qrCode: boolean,
  confirmationUrl: string,
  cancelUrl: string,
  errorUrl: string
): GraphQueryPayload {
  return {
    query: Apollo_gql`
      query PaymentLink(
        $id: UUID!
        $qrCode: Boolean!
        $confirmationUrl: String!
        $cancelUrl: String!
        $errorUrl: String!
      ) {
        paymentLink(
          invoiceId: $id
          qrCode: $qrCode
          confirmationUrl: $confirmationUrl
          cancelUrl: $cancelUrl
          errorUrl: $errorUrl
        ) {
          ${paymentLinkProps.get('invoiceId')}
          ${paymentLinkProps.get('executeLink')}
          ${paymentLinkProps.get('executeQrLink')}
          ${paymentLinkProps.get('imageLink')}
        }
      }
    `,
    variables: {
      id: id,
      qrCode: qrCode,
      confirmationUrl: confirmationUrl,
      cancelUrl: cancelUrl,
      errorUrl: errorUrl,
    },
  };
}

export function GET_PAYMENT_LINKS(
  ids: string[],
  qrCode: boolean,
  confirmationUrl: string,
  cancelUrl: string,
  errorUrl: string
): GraphPayload {
  return {
    name: 'paymentLinks',
    query: Apollo_gql`
      query PaymentLinks(
        $ids: [UUID!]!
        $qrCode: Boolean!
        $confirmationUrl: String!
        $cancelUrl: String!
        $errorUrl: String!
      ) {
        paymentLinks(
          invoiceIds: $ids
          qrCode: $qrCode
          confirmationUrl: $confirmationUrl
          cancelUrl: $cancelUrl
          errorUrl: $errorUrl
        ) {
          ${paymentLinkProps.get('invoiceId')}
          ${paymentLinkProps.get('executeLink')}
          ${paymentLinkProps.get('executeQrLink')}
          ${paymentLinkProps.get('imageLink')}
        }
      }
    `,
    variables: {
      ids: ids,
      qrCode: qrCode,
      confirmationUrl: confirmationUrl,
      cancelUrl: cancelUrl,
      errorUrl: errorUrl,
    },
  };
}

export function GET_INVOICE_TENANT_ROUTE(invoiceId: string): GraphQueryPayload {
  return {
    query: Apollo_gql`
        query InvoiceTenantRoute($invoiceId: UUID!) {
          invoiceTenantRoute(invoiceId: $invoiceId)
        }
      `,
    variables: {
      invoiceId: invoiceId,
    },
  };
}
